import styled from "styled-components";

export const Header = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 16px 0;
`;
